var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHunterStoryBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1193,
    height: 288,
    viewBox: "0 0 1193 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1_46161)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1153,
    height: 247.45,
    rx: 11.2524,
    transform: "matrix(1 0 0 -1 20 265.45)",
    fill: "url(#paint0_linear_1_46161)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5.62622,
    y: 5.62622,
    width: 1164.25,
    height: 258.702,
    rx: 16.8787,
    transform: "matrix(1 0 0 -1 20 276.702)",
    stroke: "url(#paint1_linear_1_46161)",
    strokeWidth: 11.2524
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1_46161",
    x: 0.308233,
    y: 0.55872,
    width: 1192.38,
    height: 286.834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.93835
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.281311
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.447059 0 0 0 0 0.152941 0 0 0 0 0.00392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_46161"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.25049
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.21966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.0588235 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_46161",
    result: "effect2_dropShadow_1_46161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_46161",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_46161",
    x1: 576.5,
    y1: -3.78888e-7,
    x2: 572.167,
    y2: 406.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#B7570E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E2401"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_46161",
    x1: 845.332,
    y1: 15.8523,
    x2: 747.081,
    y2: 329.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D17B0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52422,
    stopColor: "#FCA22D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728844,
    stopColor: "#CD7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#973E04"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunterStoryBoard);
export default __webpack_public_path__ + "static/media/hunter-story-board.c6bd7b89601b11139587d95921b8c87f.svg";
export { ForwardRef as ReactComponent };